import { useQuery } from '@tanstack/react-query';
import { CONF_API_URL } from 'utils/config';
import { IUser } from 'utils/models';
import storage from 'utils/storage';


export type DoctorMeResponse = {
  code?: number | string;
  success?: boolean;
  doctor?: IUser;
  is_from_admin?: boolean;
  message?: string;
};

export const useGetMe = () => {
  const query = useQuery<DoctorMeResponse>({
    queryKey: ['doctorMe'],
    queryFn: async () => {
      const token = storage.getItem('token');
      if (!token) throw new Error('No token found');

      const res = await fetch(`${CONF_API_URL}api/hazel/doctors/getCurrentDoctor`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) throw new Error('Failed to fetch profile');

      const data: DoctorMeResponse = await res.json();
      if (!data?.success || Number(data?.code) !== 200) {
        throw new Error(data?.message || 'Failed to fetch profile');
      }

      return data;
    },
    enabled: false,
    staleTime: 5 * 60 * 1000,
    retry: false
  });

  const isOk = (res?: DoctorMeResponse) =>
    Number(res?.code) === 200 && (res?.success ?? true) !== false;

  const doctorMe = async () => {
    const result = await query.refetch();
    return result.data;
  };

  return { ...query, isOk, doctorMe };
};
